import _classCallCheck from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits"; //@ts-check

import React from 'react';
import instances from './instances';

var _React$createContext = React.createContext({
  actions: {}
}),
    Provider = _React$createContext.Provider,
    Consumer = _React$createContext.Consumer;

export { Provider, Consumer };

var DataGridProvider =
/*#__PURE__*/
function (_React$Component) {
  _inherits(DataGridProvider, _React$Component);

  function DataGridProvider(props) {
    var _this;

    _classCallCheck(this, DataGridProvider);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DataGridProvider).call(this, props));

    _this.register = function (gridId, gridInstance) {
      instances.register(gridId, gridInstance);
      _this.grids[gridId] = gridInstance;
    };

    _this.unregister = function (gridId) {
      instances.unregister(gridId);
      delete _this.grids[gridId];
    };

    _this.refresh = function (gridId, e) {
      instances.refresh({
        id: gridId
      }, e);
    };

    _this.refreshAll = function (gridDataType, e) {
      instances.refresh({
        dataType: gridDataType
      }, e);
    };

    _this.state = {
      actions: {
        //public API
        // by grid id
        refresh: _this.refresh,
        // by grid dataType
        refreshAll: _this.refreshAll,
        //private
        register: _this.register,
        unregister: _this.unregister
      }
    };
    _this.grids = {};
    return _this;
  }

  _createClass(DataGridProvider, [{
    key: "render",
    value: function render() {
      return React.createElement(Provider, Object.assign({
        value: this.state.actions
      }, this.props));
    }
  }]);

  return DataGridProvider;
}(React.Component);

export { DataGridProvider as default };